// extracted by mini-css-extract-plugin
export default {"skeleton":"mExgG_LCquUrioyAp5G_"};